// extracted by mini-css-extract-plugin
export default {"form":"Reports_form__JoW3d","form__buttons":"Reports_form__buttons__x-vm1"};